import { createContext, useContext } from "react";
import type { FlexDemoSession } from "./flexDemo.session";

export type FlexDemoSessionContextValue = {
  session: FlexDemoSession;
  persist: (next: FlexDemoSession) => void;
  userId: string;
  demoActive: boolean;
  startDemo: () => void;
  cancelDemo: () => void;
  leavingDemo: boolean;
};

export const FlexDemoSessionContext = createContext<FlexDemoSessionContextValue | null>(null);

export function useFlexDemoSession(): FlexDemoSessionContextValue {
  const ctx = useContext(FlexDemoSessionContext);
  if (!ctx) {
    throw new Error("useFlexDemoSession must be used inside FlexDemoProvider");
  }
  return ctx;
}

export function useFlexDemoSessionOptional(): FlexDemoSessionContextValue | null {
  return useContext(FlexDemoSessionContext);
}
